import Login from '../../../components/Public/Login';
import PasswordReset from '../../../components/Public/PasswordReset';
import Terms from '../../../components/Public/Terms';
import Privacy from '../../../components/Public/Privacy';
import AcceptInvitation from '../../../components/Public/AcceptInvitation';

export const PUBLIC_ROUTES = {
  login: {
    path: '/login',
    exact: true,
    additional: {
      component: Login,
      protected: false,
    },
  },
  passwordReset: {
    path: '/password/reset',
    exact: true,
    additional: {
      component: PasswordReset,
      protected: false,
    },
  },
  acceptInvitation: {
    path: '/invite/:token',
    exact: true,
    additional: {
      component: AcceptInvitation,
      protected: false,
    },
  },

  terms: {
    path: '/terms',
    exact: true,
    additional: {
      component: Terms,
      protected: false,
    },
  },
  privacy: {
    path: '/privacy',
    exact: true,
    additional: {
      component: Privacy,
      protected: false,
    },
  },
}


